// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  padding: 20px 20px 20px 20px;
  text-align: center;
  border: none;
}

.card-details {
  width: 100%;
}

.title {
  font-style: normal;
  font-weight: 600;
  font-size: 19px;
}

.sub-title {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
}

.error {
  color: #d0021b;
}

.error-instruction {
  margin: 20px 0px 0px 0px;
  background-color: var(--color-header-background);
}

.invalid {
  border-color: #d0021b;
}

.countryComponent .selectionBox {
  margin-top: 3%;
}
.countryComponent .selectionBox .label {
  display: inline-block;
  position: absolute;
  font-size: 12px;
  padding-left: 15px;
  font-weight: 600;
  color: var(--color-card-text);
}
.countryComponent .selectionBox .custom-select {
  height: 45px;
  width: 90%;
  font-size: 15px;
  padding-left: 14px;
  border-radius: 2px;
  padding-top: 15px;
}
.countryComponent .selectionBox .invalid {
  height: 45px;
  font-size: 15px;
  padding-left: 14px;
  border-radius: 2px;
  border-color: #d0021b;
  width: 100%;
  background-color: white;
}

.label-overlay {
  display: inline-block;
  position: absolute;
  font-size: 12px;
  padding-left: 15px;
  font-weight: 600;
  margin-top: 14px;
  color: var(--color-card-text);
}

.input-style {
  background-color: var(--color-card-background) !important;
  color: var(--color-card-text) !important;
}

input:-webkit-autofill,
input:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:focus {
  -webkit-transition: background-color 0s 600000s, color 0s 600000s !important;
  transition: background-color 0s 600000s, color 0s 600000s !important;
}

input {
  font-weight: 600;
  font-size: 14px;
  font-style: normal;
  color: #4f4f4f;
  width: 90%;
  height: 45px;
  border: 1px solid var(--color-secondary);
  border-radius: 2px;
  padding-left: 16px;
  margin-top: 4%;
  margin-left: 0px;
}

.saveaddr {
  margin-left: 15%;
  margin-right: 15%;
}

.save {
  font-size: medium;
  margin-right: 20px;
  font-weight: 600;
  background-color: rgba(0, 0, 0, 0);
  border: none;
  color: var(--color-interaction-text);
}

.cancel {
  font-size: medium;
  font-weight: 600;
  background-color: var(--color-card-background);
  border: none;
  color: var(--color-card-text);
}

.addr {
  text-align: center;
}

.content {
  margin: 10px 0px 0px 0px;
}

::placeholder {
  font-weight: 600;
  font-size: 14px;
  font-style: normal;
  color: #4f4f4f;
}

:-ms-input-placeholder {
  font-weight: 600;
  font-size: 14px;
  font-style: normal;
  color: #4f4f4f;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/desktop/d-landing-page/return-options/update-address/update-address.component.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;AACF;;AACA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;AAEF;;AAAA;EACE,cAAA;AAGF;;AADA;EACE,wBAAA;EACA,gDAAA;AAIF;;AAFA;EACE,qBAAA;AAKF;;AAFE;EACE,cAAA;AAKJ;AAJI;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;AAMN;AAJI;EACE,YAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAMN;AAJI;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,uBAAA;AAMN;;AAFA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;AAKF;;AAHA;EACE,yDAAA;EACA,wCAAA;AAMF;;AAHA;;;;EAIE,4EAAA;EAAA,oEAAA;AAMF;;AAHA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAMF;;AAJA;EACE,gBAAA;EACA,iBAAA;AAOF;;AALA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCAAA;EACA,YAAA;EACA,oCAAA;AAQF;;AANA;EACE,iBAAA;EACA,gBAAA;EACA,8CAAA;EACA,YAAA;EACA,6BAAA;AASF;;AAPA;EACE,kBAAA;AAUF;;AARA;EACE,wBAAA;AAWF;;AARA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAWF;;AARA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAWF","sourcesContent":[".card {\n  padding: 20px 20px 20px 20px;\n  text-align: center;\n  border: none;\n}\n\n.card-details {\n  width: 100%;\n}\n\n.title {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 19px;\n}\n.sub-title {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n}\n.error {\n  color: #d0021b;\n}\n.error-instruction {\n  margin: 20px 0px 0px 0px;\n  background-color: var(--color-header-background);\n}\n.invalid {\n  border-color: #d0021b;\n}\n.countryComponent {\n  .selectionBox {\n    margin-top: 3%;\n    .label {\n      display: inline-block;\n      position: absolute;\n      font-size: 12px;\n      padding-left: 15px;\n      font-weight: 600;\n      color: var(--color-card-text);\n    }\n    .custom-select {\n      height: 45px;\n      width: 90%;\n      font-size: 15px;\n      padding-left: 14px;\n      border-radius: 2px;\n      padding-top: 15px;\n    }\n    .invalid {\n      height: 45px;\n      font-size: 15px;\n      padding-left: 14px;\n      border-radius: 2px;\n      border-color: #d0021b;\n      width: 100%;\n      background-color: white;\n    }\n  }\n}\n.label-overlay {\n  display: inline-block;\n  position: absolute;\n  font-size: 12px;\n  padding-left: 15px;\n  font-weight: 600;\n  margin-top: 14px;\n  color: var(--color-card-text);\n}\n.input-style {\n  background-color: var(--color-card-background) !important;\n  color: var(--color-card-text) !important;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:focus {\n  transition: background-color 0s 600000s, color 0s 600000s !important;\n}\n\ninput {\n  font-weight: 600;\n  font-size: 14px;\n  font-style: normal;\n  color: #4f4f4f;\n  width: 90%;\n  height: 45px;\n  border: 1px solid var(--color-secondary);\n  border-radius: 2px;\n  padding-left: 16px;\n  margin-top: 4%;\n  margin-left: 0px;\n}\n.saveaddr {\n  margin-left: 15%;\n  margin-right: 15%;\n}\n.save {\n  font-size: medium;\n  margin-right: 20px;\n  font-weight: 600;\n  background-color: rgba(0, 0, 0, 0);\n  border: none;\n  color: var(--color-interaction-text);\n}\n.cancel {\n  font-size: medium;\n  font-weight: 600;\n  background-color: var(--color-card-background);\n  border: none;\n  color: var(--color-card-text);\n}\n.addr {\n  text-align: center;\n}\n.content {\n  margin: 10px 0px 0px 0px;\n}\n\n::placeholder {\n  font-weight: 600;\n  font-size: 14px;\n  font-style: normal;\n  color: #4f4f4f;\n}\n\n:-ms-input-placeholder {\n  font-weight: 600;\n  font-size: 14px;\n  font-style: normal;\n  color: #4f4f4f;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
